import React from "react";

interface PostsEmptyStateProps {
  topicName: string;
}

const PostsEmptyState = ({ topicName }: PostsEmptyStateProps) => (
  <div className="community-shell__empty-state">
    <div className="community-shell__empty-state-icon" aria-hidden="true">
      <span className="ic" aria-hidden="true">
        <svg viewBox="0 0 32 32">
          <use href="#ic-chat"></use>
        </svg>
      </span>
    </div>
    <h3>No posts in #{topicName} yet</h3>
    <p>Start the conversation by sharing the first post in this topic.</p>
  </div>
);

export default PostsEmptyState;
